import { FC, useState } from 'react';
import { useIntl } from 'react-intl';
import PruFilter, { PruFilterItemType } from 'src/app/common/components/PruTable/PruFilter';
import { CampaignListParam } from 'src/app/modules/PruleadInsightsReporting/network/campaignCrud';
import { CampaignDropdownList, CampaignDropdownType } from 'src/app/modules/PulseLeads/types/campaign-types';
import { useDataProvider } from 'src/app/common/utils';
import { useDispatch } from 'react-redux';
import { CampaignDropdownListParam, fetchCampaignDropdownList } from 'src/app/modules/PulseLeads/network/campaignCrud';
import _ from 'lodash';
import { CampaignStatusEnum } from 'src/app/modules/PruleadInsightsReporting/types/insights-types';


type CampaignListFilterProps = {
  filterState: CampaignListParam;
  onChangeFilter: (filterState: CampaignListParam) => void;
  onSearch: () => void;
};

const CampaignListFilter: FC<CampaignListFilterProps> = ({ filterState, onChangeFilter, onSearch }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });
  const [leadSourceDropDownList, setLeadSourceDropDownList] = useState<CampaignDropdownList | undefined>({
    [CampaignDropdownType.LEAD_SOURCE]: [],
    [CampaignDropdownType.AGENT_LEAD_SOURCE]: [],
  });

  useDataProvider<CampaignDropdownList>(
    async () => {
      try {
        const params: CampaignDropdownListParam = {
          type: [CampaignDropdownType.LEAD_SOURCE, CampaignDropdownType.AGENT_LEAD_SOURCE],
        };
        return await fetchCampaignDropdownList(params, dispatch);
      } catch (err) { }
    },
    setLeadSourceDropDownList,
    false,
  );

  return (
    <PruFilter
      title={Translation('pulseleads.campaign.filter')}
      itemDef={[
        {
          type: PruFilterItemType.FREE_TEXT,
          field: 'name',
          initialValue: filterState.name,
          displayName: Translation('pulseleads.campaign.common.name'),
          style: { flex: 0.3 },
        },
        {
          type: PruFilterItemType.DROPDOWN,
          field: 'status',
          initialValue: filterState.status,
          displayName: Translation('pulseleads.campaign.common.status'),
          style: { flex: 0.2 },
          choices: [
            ..._.map([
              CampaignStatusEnum.ACTIVE,
              CampaignStatusEnum.PAUSED,
              CampaignStatusEnum.DRAFT,
            ], (option: string) => ({
              displayName: Translation(`pulseleads.campaign.status.option.${option}`),
              value: option,
            })),
          ],
        },
        {
          type: PruFilterItemType.DROPDOWN,
          field: 'sourceId',
          initialValue: filterState.sourceId,
          displayName: Translation('pulseleads.campaign.common.source'),
          style: { flex: 0.5 },
          choices: [
            { displayName: '', value: '' },
            ...(leadSourceDropDownList ? leadSourceDropDownList[CampaignDropdownType.LEAD_SOURCE].map((dropdownItem) => ({
              displayName: dropdownItem.value,
              value: dropdownItem.key,
            })) : []),
            ...(leadSourceDropDownList ? leadSourceDropDownList[CampaignDropdownType.AGENT_LEAD_SOURCE].map((dropdownItem) => ({
              displayName: dropdownItem.value,
              value: dropdownItem.key,
            })) : []),
          ],
        },
        {
          type: PruFilterItemType.DATE_RANGE,
          fieldFrom: 'startDateFrom',
          fieldTo: 'startDateTo',
          initialDateFrom: filterState.startDateFrom,
          initialDateTo: filterState.startDateTo,
          displayName: Translation('pulseleads.campaign.common.startDate'),
        },
        {
          type: PruFilterItemType.DATE_RANGE,
          fieldFrom: 'endDateFrom',
          fieldTo: 'endDateTo',
          initialDateFrom: filterState.endDateFrom,
          initialDateTo: filterState.endDateTo,
          displayName: Translation('pulseleads.campaign.common.endDate'),
        },
      ]}
      onChangeFilter={(data) =>
        onChangeFilter({
          ...filterState,
          name: data.name,
          startDateFrom: data.startDateFrom,
          startDateTo: data.startDateTo,
          endDateFrom: data.endDateFrom,
          endDateTo: data.endDateTo,
          sort: data.sort,
          sourceId: data.sourceId,
          status: data.status,
          page: 1,
        })
      }
      fetchData={onSearch}
    />
  );
};

export default CampaignListFilter;
